"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelapseComponent = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const closeTimelapseButton_svg_1 = __importDefault(require("../../../../assets/icons/closeTimelapseButton.svg"));
const hooks_1 = require("../../../../store/hooks");
const timelapseSlice_1 = require("../../../../store/timelapseSlice");
const dateFormat_1 = require("../../../../types/dateFormat");
const timelapseSelectors_1 = require("../../../../store/timelapseSelectors");
const filterTimelapseData_1 = require("../../../../utils/filterTimelapseData");
const useAutoDismissAlert_1 = require("../../../../utils/useAutoDismissAlert");
const NavigationButtons_1 = __importDefault(require("./NavigationButtons"));
const TimeAxis_1 = __importDefault(require("./TimeAxis"));
const S = __importStar(require("./TimelapseComponent.style"));
const TimeRangeButtons_1 = __importDefault(require("./TimeRangeButtons"));
const TimelapseComponent = react_1.default.memo(({ onClose }) => {
    const [showReadOnlyPopup, setShowReadOnlyPopup] = (0, react_1.useState)(false);
    const [currentStep, setCurrentStep] = (0, react_1.useState)(0);
    const isLoading = (0, hooks_1.useAppSelector)(timelapseSelectors_1.selectTimelapseIsLoading);
    const fullTimestamps = (0, hooks_1.useAppSelector)(timelapseSelectors_1.selectTimelapseData);
    const timeRange = (0, hooks_1.useAppSelector)(timelapseSelectors_1.selectTimelapseTimeRange);
    const overlayRef = (0, react_1.useRef)(null);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const resetTimelapse = (0, react_1.useCallback)(() => {
        setCurrentStep(0);
        dispatch((0, timelapseSlice_1.setCurrentTimestamp)(""));
    }, [dispatch]);
    const filteredTimestamps = (0, react_1.useMemo)(() => {
        return (0, filterTimelapseData_1.filterTimestamps)(fullTimestamps, timeRange);
    }, [fullTimestamps, timeRange]);
    (0, react_1.useEffect)(() => {
        setCurrentStep(0);
        if (filteredTimestamps.length > 0) {
            dispatch((0, timelapseSlice_1.setCurrentTimestamp)(filteredTimestamps[0]));
        }
    }, [timeRange, filteredTimestamps, dispatch]);
    const closeHandler = (0, react_1.useCallback)(() => {
        resetTimelapse();
        dispatch((0, timelapseSlice_1.resetTimelapseData)());
        onClose();
    }, [onClose, resetTimelapse, dispatch]);
    const handleNextStep = (0, react_1.useCallback)(() => {
        if (currentStep < filteredTimestamps.length - 1) {
            const nextStep = currentStep + 1;
            setCurrentStep(nextStep);
            dispatch((0, timelapseSlice_1.setCurrentTimestamp)(filteredTimestamps[nextStep]));
        }
    }, [currentStep, filteredTimestamps, dispatch]);
    const handlePreviousStep = (0, react_1.useCallback)(() => {
        if (currentStep > 0) {
            const prevStep = currentStep - 1;
            setCurrentStep(prevStep);
            dispatch((0, timelapseSlice_1.setCurrentTimestamp)(filteredTimestamps[prevStep]));
        }
    }, [currentStep, filteredTimestamps, dispatch]);
    const handleGoToStart = (0, react_1.useCallback)(() => {
        setCurrentStep(0);
        dispatch((0, timelapseSlice_1.setCurrentTimestamp)(filteredTimestamps[0]));
    }, [filteredTimestamps, dispatch]);
    const handleGoToEnd = (0, react_1.useCallback)(() => {
        const lastIndex = filteredTimestamps.length - 1;
        setCurrentStep(lastIndex);
        dispatch((0, timelapseSlice_1.setCurrentTimestamp)(filteredTimestamps[lastIndex]));
    }, [filteredTimestamps, dispatch]);
    const handleStepChange = (0, react_1.useCallback)((newStep) => {
        setCurrentStep(newStep);
        dispatch((0, timelapseSlice_1.setCurrentTimestamp)(filteredTimestamps[newStep]));
    }, [filteredTimestamps, dispatch]);
    const handleOverlayClick = (0, react_1.useCallback)((event) => {
        const targetElement = event.target;
        const isMapButton = targetElement.closest(".active-overlay");
        if (overlayRef.current &&
            !overlayRef.current.contains(event.target) &&
            !isMapButton) {
            setShowReadOnlyPopup(true);
        }
    }, [overlayRef]);
    (0, useAutoDismissAlert_1.useAutoDismissAlert)(showReadOnlyPopup, setShowReadOnlyPopup);
    (0, react_1.useEffect)(() => {
        document.addEventListener("mousedown", handleOverlayClick);
        return () => {
            document.removeEventListener("mousedown", handleOverlayClick);
        };
    }, [handleOverlayClick]);
    (0, react_1.useEffect)(() => {
        return () => {
            // Reset the current timestamp when the component unmounts
            dispatch((0, timelapseSlice_1.setCurrentTimestamp)(""));
        };
    }, [dispatch]);
    const currentTimestamp = filteredTimestamps[currentStep];
    const currentDate = (0, moment_1.default)(currentTimestamp, dateFormat_1.DateFormat.us_timestamp).format(dateFormat_1.DateFormat.us_without_year);
    const currentTime = (0, moment_1.default)(currentTimestamp, dateFormat_1.DateFormat.us_timestamp).format(dateFormat_1.DateFormat.time);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !isLoading && (react_1.default.createElement(S.TimelapseModal, { open: true, modal: true, nested: true, overlayStyle: { margin: 0, zIndex: 2 }, contentStyle: { margin: 0 }, onClose: closeHandler, closeOnDocumentClick: false },
            react_1.default.createElement("div", { ref: overlayRef },
                react_1.default.createElement(S.TimeAxisContainer, null,
                    react_1.default.createElement(S.MobileDateContainer, null,
                        react_1.default.createElement(S.Date, null, currentDate),
                        react_1.default.createElement(S.Time, null, currentTime)),
                    react_1.default.createElement(NavigationButtons_1.default, { currentStep: currentStep, totalSteps: filteredTimestamps.length, onNextStep: handleNextStep, onPreviousStep: handlePreviousStep, onGoToStart: handleGoToStart, onGoToEnd: handleGoToEnd }),
                    react_1.default.createElement(TimeAxis_1.default, { currentStep: currentStep, totalSteps: filteredTimestamps.length, timestamps: filteredTimestamps, onStepChange: handleStepChange })),
                react_1.default.createElement(TimeRangeButtons_1.default, null),
                react_1.default.createElement(S.CancelButtonX, { onClick: closeHandler },
                    react_1.default.createElement("img", { src: closeTimelapseButton_svg_1.default, alt: t("navbar.altClose") }))))),
        showReadOnlyPopup && (react_1.default.createElement(S.SmallPopup, { open: true },
            react_1.default.createElement(S.AlertInfo, null, t("timelapse.readOnly"))))));
});
exports.TimelapseComponent = TimelapseComponent;
